export const onDeleteButtonFunction = async ({
  buttonIndex,
  nodes,
  nodeId,
  edges,
  api,
  setEdges,
  setNodes,
}) => {
  console.log("DELETE BUTTON");
  var newNodes = [...nodes];
  var newSelectedNode = newNodes.find((n) => n.id === nodeId);
  const deletedButton = newSelectedNode.data.buttons[buttonIndex];
  newSelectedNode.data.buttons = newSelectedNode.data.buttons.filter(
    (_, index) => index !== buttonIndex,
  );
  const alphabetMin = [..."abcdefghijklmnopqrstuvwxyz"];
  const linkedEdges = edges.filter(
    (e) => e.source === nodeId && e.sourceHandle === alphabetMin[buttonIndex],
  );
  // Delete edges
  var newEdges = [...edges];
  if (linkedEdges.length > 0) {
    const linkedEdgesIds = linkedEdges?.map((l) => l.id);
    linkedEdges.map(
      async (e) => e.data?.edgeId && api.flowEdge.delete(e.data.edgeId),
    );
    newEdges = edges.filter((e) => !linkedEdgesIds.includes(e.id));
  }
  // Delete nodes
  try {
    if (deletedButton?.gadgetId) {
      await api.flowNode.delete(deletedButton.gadgetId);
    }
  } catch (e) {
    console.error(`Unable to delete flow node ${e}`);
  }
  try {
    if (deletedButton?.replyButtonGadgetId) {
      await api.replyButton.delete(deletedButton.replyButtonGadgetId);
    }
  } catch (e) {
    console.error(`Unable to delete reply button ${e}`);
  }
  try {
    if (deletedButton?.replyListGadgetId) {
      await api.replyList.delete(deletedButton.replyListGadgetId);
    }
  } catch (e) {
    console.error(`Unable to delete reply list ${e}`);
  }
  setEdges(newEdges);
  setNodes(newNodes);
};
